// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rankPos: __t.u32().primaryKey().name("rank_pos"),
  worldId: __t.u64().name("world_id"),
  hotScore: __t.f32().name("hot_score"),
  refreshedAt: __t.timestamp().name("refreshed_at"),
});
